import {WizardComponentController} from "../WizardComponent";
import {IAttributes, IRootElementService, IScope} from "angular";
import {WizardFooterController} from "../footer/WizardFooter";

export const WizardNext = "wizardNext";

export function wizardNext() {
    return {
        restrict: "A",
        require: ["^^tfWizard", "?^^tfWizardFooter"],
        link: ($scope: IScope,
               $elem: IRootElementService,
               $attr: IAttributes,
               wizards: [WizardComponentController, WizardFooterController | null]) => {

            const wizard = wizards[0];
            $elem.on("click", () => {
                wizard.next();
            });

            const footer = wizards[1];
            // Only do the automatic show/hide if we're in the footer
            if (footer != null) {
                const stepSub = wizard.stepChanges()
                                      .subscribe(step => {
                                          if (step.last) {
                                              $elem.css("display", "none");
                                          } else {
                                              $elem.css("display", "initial");
                                          }
                                      });
                $scope.$on("$destroy", () => stepSub.unsubscribe());
            }
        }
    };
}
